import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import { Loader2, Users } from 'lucide-react';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table';
import { Partner } from '@/types/partner';

interface PartnerTableProps {
  partners: Partner[];
  isLoading: boolean;
  error: string | null;
  onSelectPartner: (partner: Partner) => void;
}

const formatDateTime = (dateString: string) => {
  const date = new Date(dateString);
  return date.toLocaleString('pt-BR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
};

export const PartnerTable = ({
  partners,
  isLoading,
  error,
  onSelectPartner,
}: PartnerTableProps) => {
  const safePartners = Array.isArray(partners) ? partners : [];

  return (
    <Table>
      <TableHeader>
        <TableRow>
          <TableHead>Nome</TableHead>
          <TableHead>Subscription</TableHead>
          <TableHead>Data de criação</TableHead>
          <TableHead className="w-[100px] text-center">Clientes</TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {isLoading ? (
          <TableRow>
            <TableCell colSpan={4} className="p-8 text-center">
              <div className="flex items-center justify-center gap-2">
                <Loader2 className="h-4 w-4 animate-spin" />
                <span>Carregando marcas...</span>
              </div>
            </TableCell>
          </TableRow>
        ) : error ? (
          <TableRow>
            <TableCell colSpan={4} className="p-8 text-center text-red-600">
              {error}
            </TableCell>
          </TableRow>
        ) : safePartners.length === 0 ? (
          <TableRow>
            <TableCell colSpan={4} className="p-8 text-center text-gray-500">
              Nenhuma marca encontrada
            </TableCell>
          </TableRow>
        ) : (
          safePartners.map((partner) => (
            <TableRow
              key={partner.id}
              className="cursor-pointer hover:bg-muted/50"
              onClick={() => onSelectPartner(partner)}
            >
              <TableCell className="p-4 font-medium text-gray-900">{partner.name}</TableCell>
              <TableCell className="p-4">
                {partner.subscription ? (
                  <Badge variant="secondary" className="text-xs">
                    {partner.subscription}
                  </Badge>
                ) : (
                  <span className="text-gray-500">—</span>
                )}
              </TableCell>
              <TableCell className="p-4 text-gray-600">
                {formatDateTime(partner.created_at)}
              </TableCell>
              <TableCell className="p-4 text-center">
                <Button
                  variant="ghost"
                  size="sm"
                  className="h-8 w-8 p-0"
                  title="Ver clientes"
                  onClick={(e) => {
                    e.stopPropagation();
                    onSelectPartner(partner);
                  }}
                >
                  <Users className="h-4 w-4" />
                </Button>
              </TableCell>
            </TableRow>
          ))
        )}
      </TableBody>
    </Table>
  );
};
